export const FETCH_TESTS_START = 'FETCH_TESTS_START'
export const FETCH_TESTS_SUCCESS = 'FETCH_TESTS_SUCCESS'
export const FETCH_TESTS_ERROR = 'FETCH_TESTS_ERROR'
export const FETCH_TEST_SUCCESS = 'FETCH_TEST_SUCCESS'

export const TEST_SET_STATE = 'TEST_SET_STATE'
export const FINISH_TEST = 'FINISH_TEST'
export const TEST_NEXT_QUESTION = 'TEST_NEXT_QUESTION'
export const TEST_RETRY = 'TEST_RETRY'

export const CREATE_TEST_QUESTION = 'CREATE_TEST_QUESTION'
export const RESET_TEST_CREATION = 'RESET_TEST_CREATION'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'

export const ASYNC_CALL = 'ASYNC_CALL'